import React, { useState, useContext, useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import axios from 'axios';
import AuthContext from '../context/AuthContext';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUserPlus, faSpinner, faEye, faEyeSlash } from '@fortawesome/free-solid-svg-icons';

const Register = () => {
  const { token } = useParams();
  const [formData, setFormData] = useState({
    name: '',
    password: '',
    password2: ''
  });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [invitation, setInvitation] = useState(null);
  const [validatingToken, setValidatingToken] = useState(true);
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  
  const { isAuthenticated, setAuth } = useContext(AuthContext);
  const navigate = useNavigate();
  
  useEffect(() => {
    // Если пользователь уже аутентифицирован, перенаправляем его
    if (isAuthenticated) {
      navigate('/templates');
    }
  }, [isAuthenticated, navigate]);
  
  useEffect(() => {
    // Проверяем валидность токена приглашения
    const validateToken = async () => {
      try {
        setValidatingToken(true);
        const res = await axios.get(`/api/auth/invitations/validate/${token}`);
        setInvitation(res.data);
        setValidatingToken(false);
      } catch (err) {
        setError('Приглашение недействительно или истекло');
        setValidatingToken(false);
      }
    };
    
    if (token) {
      validateToken();
    } else {
      setError('Отсутствует токен приглашения');
      setValidatingToken(false);
    }
  }, [token]);
  
  const { name, password, password2 } = formData;
  
  const onChange = e => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };
  
  const onSubmit = async e => {
    e.preventDefault();
    setLoading(true);
    setError('');
    
    if (password !== password2) {
      setError('Пароли не совпадают');
      setLoading(false);
      return;
    }
    
    try {
      const res = await axios.post(`/api/auth/register/${token}`, {
        name,
        password
      });
      
      // Сохраняем токен в localStorage
      localStorage.setItem('token', res.data.token);
      
      // Обновляем контекст аутентификации
      setAuth(true, res.data.user);
      
      // Перенаправляем на главную страницу
      navigate('/templates');
    } catch (err) {
      setError(err.response?.data?.message || 'Ошибка регистрации');
      setLoading(false);
    }
  };

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };
  
  const toggleConfirmPasswordVisibility = () => {
    setShowConfirmPassword(!showConfirmPassword);
  };

  if (validatingToken) {
    return (
      <div className="text-center my-5">
        <FontAwesomeIcon icon={faSpinner} spin size="3x" className="mb-3" />
        <h3>Проверка приглашения...</h3>
      </div>
    );
  }

  return (
    <div className="row">
      <div className="col-md-6 offset-md-3 col-lg-4 offset-lg-4">
        <div className="auth-form">
          <h2 className="text-center mb-4">Регистрация по приглашению</h2>
          
          {error ? (
            <div className="alert alert-danger">{error}</div>
          ) : invitation ? (
            <div className="alert alert-info">
              Вы регистрируетесь с email: <strong>{invitation.email}</strong>
            </div>
          ) : null}
          
          {invitation && (
            <form onSubmit={onSubmit}>
              <div className="mb-3">
                <label htmlFor="name" className="form-label">Имя</label>
                <input
                  type="text"
                  className="form-control"
                  id="name"
                  name="name"
                  value={name}
                  onChange={onChange}
                  required
                />
              </div>
              
              <div className="mb-3">
                <label htmlFor="password" className="form-label">Пароль</label>
                <div className="input-group">
                  <input
                    type={showPassword ? "text" : "password"}
                    className="form-control"
                    id="password"
                    name="password"
                    value={password}
                    onChange={onChange}
                    minLength="6"
                    required
                  />
                  <button
                    type="button"
                    className="btn btn-outline-secondary"
                    onClick={togglePasswordVisibility}
                    title={showPassword ? "Скрыть пароль" : "Показать пароль"}
                  >
                    <FontAwesomeIcon icon={showPassword ? faEyeSlash : faEye} />
                  </button>
                </div>
              </div>
              
              <div className="mb-3">
                <label htmlFor="password2" className="form-label">Подтверждение пароля</label>
                <div className="input-group">
                  <input
                    type={showConfirmPassword ? "text" : "password"}
                    className="form-control"
                    id="password2"
                    name="password2"
                    value={password2}
                    onChange={onChange}
                    minLength="6"
                    required
                  />
                  <button
                    type="button"
                    className="btn btn-outline-secondary"
                    onClick={toggleConfirmPasswordVisibility}
                    title={showConfirmPassword ? "Скрыть пароль" : "Показать пароль"}
                  >
                    <FontAwesomeIcon icon={showConfirmPassword ? faEyeSlash : faEye} />
                  </button>
                </div>
              </div>
              
              <button
                type="submit"
                className="btn btn-primary w-100"
                disabled={loading}
              >
                {loading ? (
                  <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                ) : (
                  <FontAwesomeIcon icon={faUserPlus} className="me-2" />
                )}
                Зарегистрироваться
              </button>
            </form>
          )}
          
          <div className="mt-3 text-center">
            <p>
              Уже есть аккаунт? <Link to="/login">Войти</Link>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Register; 